module.exports = __webpack_public_path__ + "img/healthyFood.6ab4a1b3.jpg";